import React from 'react';
import './CompareRoomsSection.css';
import { useTranslation, Trans } from 'react-i18next';
import DiscoverButton from "../../atoms/DiscoverButton/DiscoverButton";
import compareRoomsBg from "../../../assets/compare-rooms-bg.png";
// 1. Importamos la configuración de rutas
import { routeMap } from '../../../config/routes';

const CompareRoomsSection: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language.split('-')[0] as 'es' | 'en';

  // 2. Construimos la URL usando exactamente la key que tienes en tu routeMap
  // compareRooms: { en: 'rooms/compare', es: 'habitaciones/comparar' }
  const comparePath = routeMap.compareRooms[currentLang];
  const fullUrl = `/${currentLang}/${comparePath}`;

  return (
    <section
      className="compare-rooms-section"
      style={{ backgroundImage: `url(${compareRoomsBg})` }}
    >
      <div className="compare-rooms-overlay"></div>
      <div className="compare-rooms-content">
        <h2 className="compare-rooms-title">
          <span className="compara">
            <Trans i18nKey="compareRooms:titlePart1" />
          </span>
          <span className="habitaciones">
            <Trans i18nKey="compareRooms:titlePart2" />
          </span>
        </h2>

        {/* 3. Pasamos la URL dinámica al botón */}
        <DiscoverButton link={fullUrl} />
      </div>
    </section>
  );
};

export default CompareRoomsSection;